define(function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = require('moment');

var _moment2 = babelHelpers.interopRequireDefault(_moment);

require('../js/util/google-map.js');

var TOP_DISTANCE = 400;


// $('#intro').hover(
//   function () {
//     $('.sub-menu').show('slow');
//   },
//   function () {
//     $('.sub-menu').hide('slow');
//   }
// );

var lock = $(window).width() > 768;

function resize() {
  var screenWidth = $(window).width();
  if (screenWidth > 786) {
    lock && $('.main-menu').css('display', 'block');
    lock = false;
  } else if (screenWidth < 786) {
    !lock && $('.main-menu').css('display', 'none');
    lock = true;
  }
  if (screenWidth < 786 && $('body').attr('class').indexOf('Kredito')) {
    var str_x = 'PT Fintek Digital Indonesia, <br />RDTX Tower Lt 12,<br /> Jl. Prof. Dr. Satrio. Kav. E IV No. 6 Mega Kuningan <br />\n      Kel. Karet Kuningan, Kec. Setia Budi <br />\n      Jakarta Selatan 12950';
    $('.location-address').html(str_x);
  } else if (screenWidth >= 786 && $('body').attr('class').indexOf('Kredito')) {
    var str_l = 'PT Fintek Digital Indonesia, RDTX Tower Lt. 12, Jl. Prof. Dr. Satrio. Kav. E IV No. 6 Mega Kuningan, Kel. Karet Kuningan, Kec. Setia Budi, Jakarta Selatan 12950';
    $('.location-address').html(str_l);
  }
}

$(window).on('resize', _.throttle(resize, 10));

resize();

function scrollFnc() {
  var top = $(window).scrollTop();
  var height = $(window).height();
  var processTop = $('.process-section').offset().top;
  var screenWidth = $(window).width();

  log('top');

  if (top > height) {
    $('.back-to-top').fadeIn();
  } else {
    $('.back-to-top').fadeOut();
  }
  if (top > processTop) {
    $('.process-section img').each(function (i, item) {
      if ($(item).css('marginLeft') !== 0) {
        $(item).animate({ marginLeft: 0, opacity: 1 });
      }
    });
  }
}

$(window).scroll(_.throttle(scrollFnc, 20));
scrollFnc();

var isViewNotice = window.localStorage.getItem('isViewNotice');

$('#notice-dialog').on('hidden.bs.modal', function (e) {
  window.localStorage.setItem('isViewNotice', true);
});

exports.default = {};
});